import { LayoutModule } from '@angular/cdk/layout';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
// NGX Permissions
import { NgxPermissionsModule } from './shared/modules/ngx-permissions'; 
import { ModelerEditComponent } from './pages/admin-page/components/modeler-page/modeler-edit/modeler-edit.component';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxGraphModule } from '@swimlane/ngx-graph';
import { AuthGuard, RequestService, StoreService, LoggerService, GlobalErrorHandler, LoaderService, UserDefaultsService } from './shared';
import { LayoutUtilsService, MenuConfigService, SubheaderService, PageScopeService, UrlHelperService, MeanrequestService } from './shared/services';
import { SharedModule } from './shared/shared.module';
import { LayoutComponentModule } from './shared/layout.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CKEditorModule } from 'ngx-ckeditor';
import { ImageCropperModule } from 'ngx-image-cropper';
import { EmptyComponent } from './empty/empty.component';
import { environment } from '../environments/environment';
// AoT requires an exported function for factories
export const createTranslateLoader = (http: HttpClient) => {
  return new TranslateHttpLoader(http, './assets/vertical/' + environment.orgSubType + '/i18n/', '.json');
};

@NgModule({
  declarations: [AppComponent, EmptyComponent, ModelerEditComponent],
  imports: [
    BrowserModule,
    NgxGraphModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    SharedModule,
    LayoutComponentModule,
    OverlayModule,
    HttpClientModule,
    CKEditorModule,
    ImageCropperModule,
    NgxPermissionsModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    AuthGuard,
    RequestService,
    UserDefaultsService,
    LoaderService,
    StoreService,
    LayoutUtilsService,
    MenuConfigService,
    SubheaderService,
    PageScopeService,
    UrlHelperService,
    MeanrequestService,
    LoggerService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
